exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-file__container{cursor:pointer}.input-file__select{display:-ms-flexbox;display:flex;color:#008ddf}.input-file__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;color:#adadad}.input-file__footnote--is-error{color:#ff2e1e}.input-file__icon{font-size:24px}.input-file__icon--preview-visible{padding-top:12px}.input-file__label{font-size:13px;margin-left:4px;padding-top:4px}.input-file__label--preview-visible{padding-top:16px}.input-file__preview{height:48px;width:48px;border-radius:100px;margin-right:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Input/InputFile/InputFile.scss
// module id = 727
// module chunks = 0 1 2 3